import { gql } from "urql";
export const CreateChatRoomMutation = gql `
    mutation CreateChatRoom($input: ChatRoomCreateInput!) {
        chatRooms {
            createRoom(input: $input) {
                chatRoomId
                type
                name
                description
                isGroupDm
                isArchived
                lastMessageAt
                createdByUserId
                caregiverId
                patientId
                createdAt
                updatedAt
                members {
                    chatRoomMemberId
                    userId
                    firstName
                    lastName
                    email
                    imageUrl
                    lastReadAt
                    isMuted
                    joinedAt
                }
            }
        }
    }
`;
export const UpdateChatRoomMutation = gql `
    mutation UpdateChatRoom($input: ChatRoomUpdateInput!) {
        chatRooms {
            updateRoom(input: $input) {
                chatRoomId
                name
                description
                updatedAt
            }
        }
    }
`;
export const ArchiveChatRoomMutation = gql `
    mutation ArchiveChatRoom($chatRoomId: String!) {
        chatRooms {
            archiveRoom(chatRoomId: $chatRoomId) {
                chatRoomId
                isArchived
                updatedAt
            }
        }
    }
`;
export const UnarchiveChatRoomMutation = gql `
    mutation UnarchiveChatRoom($chatRoomId: String!) {
        chatRooms {
            unarchiveRoom(chatRoomId: $chatRoomId) {
                chatRoomId
                isArchived
                updatedAt
            }
        }
    }
`;
export const AddChatRoomMembersMutation = gql `
    mutation AddChatRoomMembers($chatRoomId: String!, $userIds: [String!]!) {
        chatRooms {
            addMembers(chatRoomId: $chatRoomId, userIds: $userIds)
        }
    }
`;
export const RemoveChatRoomMemberMutation = gql `
    mutation RemoveChatRoomMember($chatRoomId: String!, $userId: String!) {
        chatRooms {
            removeMember(chatRoomId: $chatRoomId, userId: $userId)
        }
    }
`;
export const LeaveChatRoomMutation = gql `
    mutation LeaveChatRoom($chatRoomId: String!) {
        chatRooms {
            leaveRoom(chatRoomId: $chatRoomId)
        }
    }
`;
export const MarkChatRoomReadMutation = gql `
    mutation MarkChatRoomRead($chatRoomId: String!) {
        chatRooms {
            markRoomRead(chatRoomId: $chatRoomId)
        }
    }
`;
export const MuteChatRoomMutation = gql `
    mutation MuteChatRoom($chatRoomId: String!, $isMuted: Boolean!) {
        chatRooms {
            muteRoom(chatRoomId: $chatRoomId, isMuted: $isMuted)
        }
    }
`;
